/*Junais  30-05-2023*/
import * as types from "../actions/actiontype";

const initialState = {
  showWorkFlow: false,
  workFlowOptions: null,
  approvalLog : null,
  approvalDetails: null,
  remarks: null,
  processSessionId: null,

};

export default function workFlowReducer(state = initialState, action) {
  switch (action.type) {
    case types.SHOW_WORKFLOW: {
      return {
        ...state,
          showWorkFlow: action.payload
      };
    }
    case types.CLOSE_REPORT:{
      return{
        ...state,
        showWorkFlow: false
      }
    }
    case types.GET_NOTIFICATIONS_END :{
      return{
        ...state,
        approvalLog: action.payload
      }
    }
    case types.GET_APPROVAL_DETAILS_END :{
      const {data, processSessionId}= action.payload;
      return{
        ...state,
        approvalDetails: data,
        processSessionId: processSessionId
      }
    }
    case types.HANDLE_INPUT_CHANGES:{
      return{
        ...state,
        [action.payload.name]: action.payload.value,
      }
    }
    case types.EXCECUTE_PROCCESS_ACTION_END:{
      return{
        ...state,
        remarks: null,
        approvalLog: null,
        approvalDetails: null,
      }
    }

    default:
      return state;
  }
}
